import ReactDOM from 'react-dom/client'
import './index.css'
import Security from './Security'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Security />
)